import React, { useEffect, useState } from 'react';
import { Button, Box, Flex, Text, IconButton } from '@chakra-ui/react';
import { Table } from 'antd';
import { Tooltip } from '@/components/ui/tooltip';
import { RiPencilFill } from 'react-icons/ri';
import api from '../../../api';
import PropTypes from 'prop-types';
import AddHistory from './AddHistory';
import { toaster } from '@/components/ui/toaster';
import { getTenantFromDomain } from '../../../utils';

const History = ({ establishmentId: estId }) => {
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const [data, setData] = useState([]);
  const [editItem, setEditItem] = useState(null);
  // const toast = useToast();

  const getEstablishmentHistory = async id => {
    try {
      const response = await api.get(`/op-audit-reasons/${id}`);
      if (response.ok) {
        const json = await response.json();
        setData(json);
      }
    } catch (error) {
      toaster.create({
        title: error.message,
        status: 'error',
      });
    }
  };

  useEffect(() => {
    if (estId) {
      getEstablishmentHistory(estId);
    }
  }, [estId]);

  useEffect(() => {
    if (!isOpenPopup) {
      setEditItem(null);
    }
  }, [isOpenPopup]);

  const tenant = getTenantFromDomain();
  const getFontFamily = () => (tenant === 'cfc' ? 'Poppins' : undefined);

  return (
    <>
      <Box marginBottom="15px">
        <Flex justifyContent="space-between" alignItems="center" marginBottom="15px">
          <Text
            color="rgba(0, 0, 0, 0.87)"
            fontSize="14px"
            fontWeight="600"
            lineHeight="1.43"
            fontFamily={getFontFamily()}
          >
            ASL Status & History
          </Text>
          <Button
            variant="unstyled"
            height="auto"
            lineHeight="1"
            color={tenant === 'cfc' ? '#0F1B48' : '#3A44B0'}
            fontSize="12px"
            fontWeight="500"
            fontFamily={getFontFamily()}
            onClick={() => setIsOpenPopup(true)}
          >
            Add New
          </Button>
        </Flex>
        <Table
          pagination={{
            pageSize: 10,
            current: 1,
            style: { display: 'none', fontFamily: getFontFamily() },
          }}
          rowClassName="food-safety-table-row"
          className="food-safety-table"
          dataSource={data}
          columns={[
            {
              title: (
                <span style={{ fontFamily: getFontFamily() }}>
                  DELISTED DATE
                </span>
              ),
              dataIndex: 'delisted_date',
              key: 'delisted_date',
              sortOrder: 'descend',
            },
            {
              title: (
                <span style={{ fontFamily: getFontFamily() }}>
                  AUDIT FAILURE
                </span>
              ),
              dataIndex: 'audit_failure',
              key: 'audit_failure',
            },
            {
              title: (
                <span style={{ fontFamily: getFontFamily() }}>
                  REASON
                </span>
              ),
              dataIndex: 'audit_reason',
              key: 'audit_reason',
            },
            {
              title: (
                <span style={{ fontFamily: getFontFamily() }}>
                  RE-INSTATED DATE
                </span>
              ),
              dataIndex: 'reinstated_date',
              key: 'reinstated_date',
              render: date => date || '-',
            },
            {
              title: (
                <span style={{ fontFamily: getFontFamily() }}>
                  ACTION
                </span>
              ),
              dataIndex: 'action',
              key: 'action',
              render: (text, record) => (
                <Tooltip content="Edit">
                  <IconButton
                    width="24px"
                    height="24px"
                    padding="0"
                    minW="auto"
                    border="1px solid #D9DADF"
                    borderRadius="2px"
                    color="#00000099"
                    backgroundColor="#fff"
                    fontFamily={getFontFamily()}
                    onClick={() => {
                      setIsOpenPopup(true);
                      setEditItem(record);
                    }}
                  >
                    <RiPencilFill size={12} />
                  </IconButton>
                </Tooltip>
              ),
            },
          ]}
        />
        {isOpenPopup && (
          <AddHistory
            isOpenPopup={isOpenPopup}
            setIsOpenPopup={setIsOpenPopup}
            estId={estId}
            editItem={editItem}
            setData={setData}
          />
        )}
      </Box>
    </>
  );
};

History.propTypes = {
  establishmentId: PropTypes.number,
};

export default History;
